import './index.scss';
const VIDEO_TYPES = {
  clip: 'clip',
  live: 'live',
  video: 'video'
};
const VIDEO_URLS = {
  clip: 'clips.twitch.tv/embed',
  live: 'player.twitch.tv',
  video: 'player.twitch.tv'
};
function TwitchPlayer({
  live,
  postId,
  creator,
  productType
}) {
  function getVideoType() {
    if (live) {
      return VIDEO_TYPES.live;
    }
    if (productType === 'twitch_clip') {
      return VIDEO_TYPES.clip;
    }
    return VIDEO_TYPES.video;
  }
  function getSearchParams() {
    const defaultSearchParams = {
      parent: encodeURI(window?.location?.hostname),
      autoplay: false
    };
    switch (videoType) {
      case VIDEO_TYPES.clip:
        return new URLSearchParams({
          ...defaultSearchParams,
          clip: postId
        });
      case VIDEO_TYPES.live:
        {
          // remove character `v` from id's beginning
          const formattedId = postId?.slice(1);
          return new URLSearchParams({
            ...defaultSearchParams,
            channel: creator?.title,
            video: formattedId
          });
        }
      case VIDEO_TYPES.video:
      default:
        return new URLSearchParams({
          ...defaultSearchParams,
          video: postId
        });
    }
  }
  const videoType = getVideoType();
  const embedUrl = VIDEO_URLS[videoType];
  const searchParams = getSearchParams();
  return <div className="TwitchPlayer">
      <iframe title={postId} src={`https://${embedUrl}?${searchParams.toString()}`} width="896" height="560" style={{
      border: 'none',
      overflow: 'hidden'
    }} frameBorder="0"
    // eslint-disable-next-line react/no-unknown-property
    allowTransparency="true" allowFullScreen="true"></iframe>
    </div>;
}
export default TwitchPlayer;